import React from "react";

const SHOW_MORE = "Show More";
const SHOW_LESS = "Show Less";

interface State {
    isMore: any,
    styles: any,
    text: any
}

class SeoText extends React.Component<any> {
    private readonly seoTextContentRef: React.RefObject<HTMLDivElement>;

    private readonly seoTextBtn: React.RefObject<HTMLButtonElement>;

    readonly state: State;

    constructor(props: any) {
        super(props);

        this.state = {
            isMore: false,
            styles: undefined,
            text: (this.props as any).text
        };

        this.seoTextContentRef = React.createRef();
        this.seoTextBtn = React.createRef();

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const { isMore } = this.state;
        this.toggleText(isMore);
        this.setIsMoreState(!isMore);
    }

    componentDidUpdate(prevProps: any) {
        const { text: currText } = this.props as any;
        const { text: prevText } = prevProps;

        if (currText !== prevText) {
            this.toggleText(false);
            this.setIsMoreState(true);
            this.setTextState(currText);
        }
    }

    toggleText(isMore: any) {
        const { current: seoTextContent } = this.seoTextContentRef;
        const { current: seoTextBtn } = this.seoTextBtn;

        if (!isMore) {
            seoTextContent?.classList.add("show-less-text");
            seoTextBtn?.classList.add("translateY-to-top-8px");
            seoTextContent?.classList.add("fade-bottom-text");
        } else {
            seoTextContent?.classList.remove("show-less-text");
            seoTextBtn?.classList.remove("translateY-to-top-8px");
            seoTextContent?.classList.remove("fade-bottom-text");
        }
    }

    handleClick() {
        const { isMore } = this.state;

        this.toggleText(isMore);
        this.setIsMoreState(!isMore);
    }

    setIsMoreState(newState: any, callBack?: any) {
        this.setState({
            isMore: newState
        }, callBack);
    }

    setTextState(newState: any, callBack?: any) {
        this.setState({
            text: newState
        }, callBack);
    }

    setStylesState(newState: any, callBack?: any) {
        this.setState({
            styles: newState
        }, callBack);
    }

    removeStylesTag() {
        const { current: seoTextContent } = this.seoTextContentRef;
        const styleTag = seoTextContent?.querySelector("style");

        if (styleTag) {
            styleTag.remove();
        }
    }

    removeStylesTagFromText(text: any) {
        const regex = /<style>([\S\s]*?)<\/style>/gm; // will match everything between "<style> & </style>" (multiline)

        let m;
        while ((m = regex.exec(text)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            // The result can be accessed through the `m`-variable.
            for (let i = 0; i < m.length; i++) {
                // index = 0 -> returns match together with "<style></style>" tags,
                // index = 1 -> returns only what is between "<style></style>" tags
                if (i === 0) {
                    return text.replaceAll(m[i], "");
                }
            }
        }

        return text;
    }

    extractStyles(text: any) {
        const regex = /<style>([\S\s]*?)<\/style>/gm; // will match everything between "<style> & </style>" (multiline)

        let m;
        while ((m = regex.exec(text)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            // The result can be accessed through the `m`-variable.
            m.forEach((match, groupIndex) => {
                // groupIndex = 0 -> returns match together with "<style></style>" tags,
                // groupIndex = 1 -> returns only what is between "<style></style>" tags
                if (groupIndex === 1) {
                    // !important needed to ovveride styles which are applied before style tag is injected
                    match = match.replaceAll(";", " !important;");
                    this.setStylesState(match);
                }
            });
        }
    }

    render() {
        const { isMore, text, styles } = this.state;

        return (
            <div className="seo-text-container">
                <style type="text/css">
                    { styles }
                </style>
                <div
                    data-testid="__seoText-testId__"
                    dangerouslySetInnerHTML={{  __html: text }}
                    className="fade-bottom-text"
                    ref={this.seoTextContentRef}
                >
                </div>
                <button
                    data-testid="__seoTextBtn-testId__"
                    className="show-more-less-btn"
                    onClick={this.handleClick}
                    ref={this.seoTextBtn}
                >
                    { !isMore ? SHOW_LESS : SHOW_MORE }
                </button>
            </div>
        );
    }
}
export default SeoText;